import { useState } from "react";
import { ExpandedState } from "@tanstack/react-table";
import {
    Form1099NecRow,
    getForm1099DefaultExpandedState,
    mergeForm1099ExpandedState,
} from "./form1099NecFormat";

export function useForm1099ExpandedState(rows: Form1099NecRow[]) {
    const [expanded, setExpanded] = useState<ExpandedState>(() =>
        getForm1099DefaultExpandedState(rows),
    );
    const [trackedRows, setTrackedRows] = useState(rows);

    if (trackedRows !== rows) {
        const previousRowIds = new Set(trackedRows.map((row) => row.id));
        setTrackedRows(rows);
        setExpanded((current) =>
            mergeForm1099ExpandedState({ current, rows, previousRowIds }),
        );
    }

    return { expanded, setExpanded };
}
